import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-date',
  template: `
    <div
      class='widget-border'
      data-testid="widget-date"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-date-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-date-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetDateComponent extends WidgetInputDirective {
}
